import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["title", "disabled"]


export default /*@__PURE__*/_defineComponent({
  __name: 'checkbox_button',
  props: /*@__PURE__*/_mergeModels({
    readOnly: {
      default: false,
      required: false,
      type: Boolean
    },
    falsifiable: {
      default: true,
      required: false,
      type: Boolean
    },
    nullable: {
      default: false,
      required: false,
      type: Boolean
    },
    title: {
      default: null,
      required: true,
      type: String
    }
  }, {
    "value": {
    default: null,
    required: true,
    type: Boolean
  },
    "valueModifiers": {},
  }),
  emits: ["update:value"],
  setup(__props) {

  const props = __props

  const value = _useModel(__props, "value")
  
  function switchValue() {
    if (!props.falsifiable) {
      switch (value.value) {
        case true:
          value.value = null
          return
        default:
          value.value = true
          return
      }
    }
    if (!props.nullable) {
      switch (value.value) {
        case true:
          value.value = false
          return
        case false:
          value.value = true
          return
        default:
          value.value = true
          return
      }
    }
    switch (value.value) {
      case true:
        value.value = false
        return
      case false:
        value.value = null
        return
      default:
        value.value = true
        return
    }
  }
  
  function switchClass(): string {
    if (!props.falsifiable) {
      switch (value.value) {
        case true:
          return "true"
        default:
          return null
      }
    }
    if (!props.nullable) {
      switch (value.value) {
        case true:
          return "true"
        default:
          return "false"
      }
    }
  
    switch (value.value) {
      case false:
        return "false"
      case true:
        return "true"
      default:
        return null
    }
  }

return (_ctx: any,_cache: any) => {
  const _component_scoped = _resolveComponent("scoped")!

  return (_openBlock(), _createBlock(_component_scoped, null, {
    default: _withCtx(() => [
      _createElementVNode("button", {
        title: __props.title,
        class: _normalizeClass(switchClass()),
        disabled: __props.readOnly,
        onClick: _cache[0] || (_cache[0] = ($event: any) => (switchValue()))
      }, _toDisplayString(__props.title), 11, _hoisted_1)
    ]),
    _: 1
  }))
}
}

})